import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundHandleKeydown = this._handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.boundHandleKeydown)
    this.element.addEventListener("turbo:submit-start", this._disableForm.bind(this))
    this.element.addEventListener("submit", this._blockIfProcessing.bind(this))

    // If loader is active when form connects (replaced mid-processing), stay disabled
    if (this._isProcessing()) {
      this._disableForm()
      this._watchLoader()
    }
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.boundHandleKeydown)
    if (this._loaderObserver) this._loaderObserver.disconnect()
  }

  _isProcessing() {
    const loader = document.getElementById('loader')
    return loader && loader.children.length > 0
  }

  _blockIfProcessing(event) {
    if (this._isProcessing()) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  _disableForm() {
    const textarea = this.element.querySelector("textarea")
    const submitBtn = this.element.querySelector('button[type="submit"]')
    if (textarea) {
      textarea.disabled = true
      textarea.placeholder = "Waiting for response…"
    }
    if (submitBtn) {
      submitBtn.disabled = true
      submitBtn.style.opacity = "0.4"
    }
  }

  _enableForm() {
    const textarea = this.element.querySelector("textarea")
    const submitBtn = this.element.querySelector('button[type="submit"]')
    if (textarea) {
      textarea.disabled = false
      textarea.placeholder = "Ask anything about your data, or @mention a table…"
      textarea.focus()
    }
    if (submitBtn) {
      submitBtn.disabled = false
      submitBtn.style.opacity = ""
    }
    if (this._loaderObserver) {
      this._loaderObserver.disconnect()
      this._loaderObserver = null
    }
  }

  // Watch #loader — when it becomes empty, re-enable the form
  _watchLoader() {
    const loader = document.getElementById('loader')
    if (!loader) return

    this._loaderObserver = new MutationObserver(() => {
      if (loader.children.length === 0) {
        this._enableForm()
      }
    })
    this._loaderObserver.observe(loader, { childList: true })
  }

  _handleKeydown(event) {
    if (event.key === "Enter") {
      if (event.metaKey || event.ctrlKey) {
        event.preventDefault()
        if (this._isProcessing()) return
        const submitButton = this.element.querySelector('button[type="submit"], input[type="submit"]')
        if (submitButton) {
          submitButton.click()
        } else if (typeof this.element.requestSubmit === "function") {
          this.element.requestSubmit()
        } else {
          this.element.submit()
        }
      }
    }
  }
}
